import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const AppNavContext = /*#__PURE__*/React.createContext(null);
function AppNavProvider(_ref) {
  let {
    navLinkGroup,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(AppNavContext.Provider, {
    value: navLinkGroup,
    children: children
  });
}
let AppNavConsumer = AppNavContext.Consumer;
export { AppNavConsumer, AppNavContext, AppNavProvider };